/* eslint-disable no-empty-pattern */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { takeLatest, call, put, all, select } from 'redux-saga/effects';
import { ActionType } from 'typesafe-actions';
import api from '../../../services/api';
import api_load from '../../../services/api_load';
import * as actions from './actions';
import * as actionsAuth from './../auth/actions';
import * as actionsParameter from './../parameter/actions'
import { MethodsProps, MethodsType, ParameterActionTypes } from './types';
import { UserAddresses, UserAddressShipping } from '../auth/types';
import {
  getMockShippingRates,
  USE_SHIPPING_MOCK,
} from '../../../mocks/shippingMock';
import { uuid } from 'uuidv4';
import { AddressSelectedProps } from '../../../hooks/useCheckoutInfo';
import httpsAdapter from '../../../adapters/https/https-adapter';
import { config } from '../../../config';
import { StoreState } from '../../createStore';

const erroMessage = 'Ops! ocorreu um erro no servidor';

export function* findMethods({}: ActionType<typeof actions.findMethods>) {
  try {
    const { data } = yield call(api.get, 'methods');

    yield put(actions.findMethodsSuccess(data.data.methods));
    yield put(actionsAuth.customerUpdateMethodsSuccess(data.data.methods));
  } catch (err) {
    if (err.response.status === 401) {
      yield put(actionsAuth.signOut());
    } else if (err.response.status === 422) {
      yield put(actions.findMethodsSuccess([]));
      yield put(actionsAuth.customerUpdateMethodsSuccess([]));
    } else if (err.response.status >= 500 && err.response.status <= 599) {
      yield put(actions.setMessageToast({type:'error', message:erroMessage }));
    }

    yield put(actions.clearLoading());
  }
}

export function* findMethodsAll({}: ActionType<typeof actions.findMethodsAll>) {
  try {
    const { data } = yield call(api.get, 'methods/all');

    if (config.isNewLayoutChosePayment) {
      const methodsCard = ['credit', 'debit'];

      const methodsType: MethodsType = {
        options: {
          cards: [],
          cashOnDelivery: [],
          others: [],
        },
        methodsLength: data.data.medias.length
      }

      data.data.medias?.forEach((method: MethodsProps) => {
        if (method.method === 'cashondelivery') {
          methodsType.options.cashOnDelivery.push(method);
        }
        else if (methodsCard.includes(method.type as string)) {
          methodsType.options.cards.push(method);
        } else {
          methodsType.options.others.push(method);
        }
      })

      yield put(actions.findMethodsTypeSuccess(methodsType));
    } else {
      yield put(actions.findMethodsAllSuccess(data.data.medias));
    }
  } catch (err) {
    if (err.response.status === 401) {
      yield put(actionsAuth.signOut());
    } else if (err.response.status >= 500 && err.response.status <= 599) {
      yield put(actions.setMessageToast({type:'error', message:erroMessage }));
    }

    yield put(actions.clearLoading());
  }
}

export function* findMethodById({
  payload,
}: ActionType<typeof actions.findMethodById>) {
  try {
    const { data } = yield call(
      api.get,
      `methods/medias/${payload.method_id}`,
    );
    //konsole.log(data)

    yield put(actions.findMethodByIdSuccess(data.data.methods));
  } catch (err) {
    yield put(actions.findMethodByIdFailure());
    if (err.response.status === 401) {
      yield put(actionsAuth.signOut());
    } else if (err.response.status >= 500 && err.response.status <= 599) {
      yield put(actions.setMessageToast({type:'error', message:erroMessage }));
    }

    yield put(actions.clearLoading());
  }
}

export function* methodSelected({
  payload,
}: ActionType<typeof actions.methodSelectedRequest>) {
  try {
    //konsole.log('userPaymentSelected payload:', payload);
    const { data: dataMethod } = yield call(
      api.post,
      `methods/selected`,
      {
        method_id: payload.method_id,
      }
    );
    //konsole.log('dataMethod: ', dataMethod.data.method)
    yield put(actions.methodSetSelected(dataMethod.data.method));
    yield put(actions.findMethods());
  } catch (err) {
    //konsole.log(err.getMessages());
    if (err.response.status === 401) {
      yield put(actionsAuth.signOut());
    } else if (err.response.status >= 500 && err.response.status <= 599) {
      yield put(actions.setMessageToast({type:'error', message:erroMessage }));
    }

    yield put(actions.clearLoading());
  }
}

export function* addressesAll() {
  try {
    const { data } = yield call(api.get, 'addresses');
    yield put(actions.addresssAllSuccess(data.data));
    yield put(actionsAuth.customerUpdateAddressSuccess(data.data));
  } catch (err) {
    //konsole.log('findAddressesAll: ', err.response.status)
    yield put(actions.addresssAllFailure());
    yield put(actionsAuth.customerUpdateAddressSuccess([]));
    if (err.response.status === 401) {
      yield put(actionsAuth.signOut());
    } else if (err.response.status >= 500 && err.response.status <= 599) {
      yield put(actions.setMessageToast({type:'error', message:erroMessage }));
    }
  }
}

export function* findStoreAll() {
  try {
    const { parameter}: StoreState = yield select();
    if (parameter.stores && parameter.stores.length > 0) {
      yield put(actions.findStoreAllSuccess(parameter.stores));
      return;
    }

    const { data } = yield call(api.get, 'store');

    yield put(actions.findStoreAllSuccess(data.data.stores));
  } catch (err) {
    yield put(actions.findStoreAllFailure());
    if (err.response.status === 401) {
      yield put(actionsAuth.signOut());
    }  else if (err.response.status === 422) {
       yield put(actions.findStoreAllSuccess([]));
    } else if (err.response.status >= 500 && err.response.status <= 599) {
      yield put(actions.setMessageToast({type:'error', message:erroMessage }));
    }
  }
}

export function* findLockerAll({
  payload,
}: ActionType<typeof actions.findLockerAll>) {
  try {
    const { data } = yield call(api_load.get, 'locker');

    yield put(actions.findLockerAllSuccess(data.data.lockers));
  } catch (err) {
    yield put(actions.findStoreAllFailure());
    if (err.response.status === 401) {
      yield put(actionsAuth.signOut());
    } else if (err.response.status >= 500 && err.response.status <= 599) {
      yield put(actions.setMessageToast({type:'error', message:erroMessage }));
    }
  }
}

export function* findShippingValue({
  payload,
}: ActionType<typeof actions.findShippingValue>) {
  try {
    let shippingData;
    // Usa mock em desenvolvimento se estiver ativo
    if (USE_SHIPPING_MOCK && process.env.NODE_ENV === 'development') {
      shippingData = yield call(getMockShippingRates);
    } else {
      // cart/rates/{METHOD}/{CART_ID}/{ZIP_CODE}
      const { data } = yield call(
        api.get,
        `cart/rates/${payload.method}?postcode=${payload.address.postcode}&number=${payload.address.number}&address_id=${payload.address.id}`,
      );

      if (data.data.length === 0) {
        yield put(actions.setMessageToast({
          type: 'error', message: "Frete não entrado para o endereço selecionado"
        }));
        yield put(actions.clearLoading());
        yield put(actions.findShippingValueSuccess([]));
        payload.setaddressSelect({} as AddressSelectedProps);
      }

      shippingData = data.data.map((shipping: UserAddressShipping) => ({
        ...shipping,
        id: uuid()
      }));
    }

    //konsole.log('findShippingValue: ', shippingData)

    yield put(actions.findShippingValueSuccess(shippingData));
  } catch (err) {
    if (err.response && err.response.status === 401) {
      yield put(actionsAuth.signOut());
    } else if (
      err.response &&
      err.response.status >= 500 &&
      err.response.status <= 599
    ) {
      yield put(actions.setMessageToast({type:'error', message:erroMessage }));
    }
    payload.setaddressSelect({} as AddressSelectedProps);
    yield put(actions.clearLoading());
  }
}

export function* calculateShippingRatesSpecific({
  payload,
}: ActionType<typeof actions.calculateShippingRatesSpecificRequest>) {
  try {
      const { data } = yield call(
        api.post,
        `cart/rates-specific`,
        {
          "carrier": payload.selectedShippingOption.carrier,
          "options": {
            "postcode": payload.postcode,
            "date": payload.selectedShippingOption.chosen_shipping_date,
            "number": payload.number,
            "address_id": payload.addressId.toString()
          }
        },
      );

    yield put(actions.calculateShippingRatesSpecificSuccess({
      ...payload.selectedShippingOption,
      price: data.data.price,
      price_with_return: data.data.price_with_return
    }));
  } catch (err) {
    if (err.response && err.response.status === 401) {
      yield put(actionsAuth.signOut());
    } else if (
      err.response &&
      err.response.status >= 500 &&
      err.response.status <= 599
    ) {
      yield put(actions.setMessageToast({type:'error', message:erroMessage }));
    }
    payload.setaddressSelect({} as AddressSelectedProps);
    yield put(actions.clearLoading());
  }
}

export function* userCreatedMethod({
  payload,
}: ActionType<typeof actions.methodCreated>) {
  try {
    //konsole.log('userCreateMethod: ', payload);
    if (payload.card.id && payload.card.id > 0) {
      yield call(
        [httpsAdapter, httpsAdapter.request],
        {
          data: {
            media_id: payload.media.media_id,
            method: payload.media.method,
            method_id: payload.card.id,
            card_number: payload.card.card_number,
            card_last_four: payload.card.card_last_four,
            tef_token: payload.card.tef_token,
            tef_nita: payload.card.tef_nita,
            full_name: payload.card.full_name,
            expiry_date: payload.card.expiry_date,
            customer_doc: payload.card.customer_doc,
          },
          isEncrypt: config.isEncryptData,
          method: 'POST',
          path: 'api/methods/update',
        }
      );
    } else {
      yield call(
        [httpsAdapter, httpsAdapter.request],
        {
          data: {
            card_number: payload.card.card_number,
            full_name: payload.card.full_name,
            expiry_date: payload.card.expiry_date,
            media_id: payload.media.media_id,
            method: payload.media.method,
            customer_doc: payload.card.customer_doc,
          },
          method: 'post',
          path: 'api/methods/create',
          isEncrypt: config.isEncryptData,
        }
      );
    }

    const { data: methods } = yield call(api.get, `methods`);

    yield put(actions.methodCreatedSuccess(methods.data.methods));
    yield put(actions.findMethods());
  } catch (err) {
    //konsole.log(err);
    if (err.response.status === 401) {
      yield put(actionsAuth.signOut());
    } else if (err.response.status === 422) {
      yield put(actionsParameter.setMessageToast({ type: 'error', message: (err as any).response.data.data }));
    } else if (err.response.status >= 500 && err.response.status <= 599) {
      yield put(actions.setMessageToast({type:'error', message:erroMessage }));
    }

    yield put(actions.clearLoading());
  }
}

export function* methodFavorite({
  payload,
}: ActionType<typeof actions.methodFavorite>) {
  try {
    //konsole.log('methodFavorite payload:', payload);
    const { data } = yield call(
      api.post,
      `methods/selected`,
      {
        method_id: payload.method_id,
      },
    );
    yield put(actions.methodFavoriteSuccess(data.data.method));
    yield put(actions.findMethods());
  } catch (err) {
    //konsole.log(err.getMessages());
    if (err.response.status === 401) {
      yield put(actionsAuth.signOut());
    } else if (err.response.status >= 500 && err.response.status <= 599) {
      yield put(actions.setMessageToast({type:'error', message:erroMessage }));
    }

    yield put(actions.clearLoading());
  }
}

export function* methodRemove({
  payload,
}: ActionType<typeof actions.methodRemove>) {
  try {
    //konsole.log('methodRemove payload:', payload);
    yield call(api.delete, `methods/${payload.method_id}`);

    //konsole.log('methodRemove data:', data);
    yield put(actions.methodRemoveSuccess());
    yield put(actions.findMethods());
  } catch (err) {
    if (err.response.status === 401) {
      yield put(actionsAuth.signOut());
    }
    if (err.response.status >= 500 && err.response.status <= 599) {
      yield put(actions.setMessageToast({type:'error', message:erroMessage }));
    }

    yield put(actions.clearLoading());
  }
}

export function* addressesSelected({
  payload,
}: ActionType<typeof actions.addressesSelectedRequest>) {
  try {
    if (payload.bSendApi) {
      yield call(
        api.post,
        'addresses/selected',
        {
          address_id: payload.addresse.id,
        }
      );
      yield put(actions.addresssAll());
    }

    yield put(actions.addressesSelectedSuccess(payload.addresse));
  } catch (err) {
    // yield put(actions.findCategoryFailure());
    if (err.response.status === 401) {
      yield put(actionsAuth.signOut());
    } else if (err.response.status >= 500 && err.response.status <= 599) {
      yield put(actions.setMessageToast({type:'error', message:erroMessage }));
    }

    yield put(actions.clearLoading());
  }
}

export function* addresssPostcodeRequest({
  payload,
}: ActionType<typeof actions.addresssPostcodeRequest>) {
  try {
    const requestCEP = {
      cep: payload.postCode,
    };

    const {
      data: { data },
    } = yield call(api.post, 'addresses/search/cep', requestCEP);

    yield put(actions.addresssPostcodeSuccess(data));
  } catch (err) {
    yield put(actions.addresssPostcodeFailure());
    if (err.response.status === 401) {
      yield put(actionsAuth.signOut());
    } else if (err.response.status >= 500 && err.response.status <= 599) {
      yield put(actions.setMessageToast({type:'error', message:erroMessage }));
    }

    yield put(actions.clearLoading());
  }
}

export function* addressesCreatedOrUpdateRequest({
  payload,
}: ActionType<typeof actions.addressesCreatedOrUpdateRequest>) {
  try {
    //konsole.log('addressesCreatedOrUpdateRequest()->payload: ', payload)

    const addressRequest: UserAddresses = {
      address_id: payload.addresse.id ? payload.addresse.id.toString() : '',
      name: payload.addresse.address_name,
      country: 'BR',
      country_name: 'Brasil',
      ...payload.addresse,
    };

    //konsole.log('addressesCreatedOrUpdateRequest->addressRequest: ', addressRequest);
    if (addressRequest.id > 0) {
      // Vamos atualizar
      yield call(api.put, `addresses/${addressRequest.id}`, addressRequest);
    } else {
      // Vamos criar um novo endereço
      const { data } = yield call(api.post, `addresses/create`, addressRequest);
      yield put(actions.addressesEditRequest(data.data));
    }
    yield put(actions.addressesCreatedOrUpdateSuccess());
    yield put(actions.addresssAll());
  } catch (err) {
    //konsole.log('addressesCreatedOrUpdateRequest->err: ', err);
    yield put(actions.addressesCreatedOrUpdateFailure());
    if (err.response.status === 401) {
      yield put(actionsAuth.signOut());
    } else if (err.response.status >= 500 && err.response.status <= 599) {
      yield put(actions.setMessageToast({type:'error', message:erroMessage }));
    }

    yield put(actions.clearLoading());
  }
}

export function* addressesRemoveRequest({
  payload,
}: ActionType<typeof actions.addressesRemoveRequest>) {
  try {
    yield call(api.delete, `addresses/${payload.addresse.id}`);

    yield put(actions.addressesRemoveSuccess());
    yield put(actions.addresssAll());
  } catch (err) {
    //konsole.log('addressesCreatedOrUpdateRequest->err: ', err);
    yield put(actions.addressesRemoveFailure());
    if (err.response.status === 401) {
      yield put(actionsAuth.signOut());
    } else if (err.response.status >= 500 && err.response.status <= 599) {
      yield put(actions.setMessageToast({type:'error', message:erroMessage }));
    }

    yield put(actions.clearLoading());
  }
}
export function* languageSelector() {
  yield put(actions.clearLoading());
  return 'language';
}

export function* updateCoordinatesRequest({
  payload,
}: ActionType<typeof actions.updateCoordinatesRequest>) {
  try {
    yield call(api.patch, `addresses/coords/${payload.id}`, payload.coordinates);
    yield put(actions.addresssAll());
  } catch (err) {
    if (err.response.status === 401) {
      yield put(actionsAuth.signOut());
    } else if (err.response.status >= 500 && err.response.status <= 599) {
      yield put(actions.setMessageToast({type:'error', message:erroMessage }));
    }
    yield put(actions.clearLoading());
  }
}

export default all([
  takeLatest(ParameterActionTypes.FIND_METHODS, findMethods),
  takeLatest(ParameterActionTypes.FIND_METHODS_ALL, findMethodsAll),
  takeLatest(ParameterActionTypes.FIND_METHOD_ID, findMethodById),
  takeLatest(ParameterActionTypes.METHOD_SEL, methodSelected),
  takeLatest(ParameterActionTypes.METHOD_CREATER, userCreatedMethod),
  takeLatest(ParameterActionTypes.ADDRESSES_FIND_ALL_REQUEST, addressesAll),
  takeLatest(ParameterActionTypes.FIND_STORE_ALL, findStoreAll),
  takeLatest(ParameterActionTypes.FIND_LOCKER_ALL, findLockerAll),
  takeLatest(ParameterActionTypes.FIND_SHIPPING_VALUE, findShippingValue),
  takeLatest(ParameterActionTypes.METHOD_FAVORITE, methodFavorite),
  takeLatest(ParameterActionTypes.METHOD_REMOVE, methodRemove),
  takeLatest(ParameterActionTypes.ADDRESSES_SEL, addressesSelected),
  takeLatest(
    ParameterActionTypes.ADDRESSES_FIND_POSTCODE_REQUEST,
    addresssPostcodeRequest,
  ),
  takeLatest(
    ParameterActionTypes.ADDRESSES_CREATED_UPDATE_REQUEST,
    addressesCreatedOrUpdateRequest,
  ),
  takeLatest(
    ParameterActionTypes.ADDRESSES_REMOVE_REQUEST,
    addressesRemoveRequest,
  ),
  takeLatest(ParameterActionTypes.SELECT_LANGUAGE, languageSelector),
  takeLatest(ParameterActionTypes.CALCULATE_SHIPPING_RATE_SPECIFC, calculateShippingRatesSpecific),
  takeLatest(ParameterActionTypes.UPDATE_COORDINATES_REQUEST, updateCoordinatesRequest),
]);
